import users from "./modules/users";
import students from "./modules/students";
import classes from "./modules/classes";
import subjects from "./modules/subjects";
export default{
    users,students,classes,subjects
}